import { render, staticRenderFns } from "./BindsTableThead.vue?vue&type=template&id=499cf468&"
import script from "./BindsTableThead.vue?vue&type=script&lang=js&"
export * from "./BindsTableThead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports